import translate from "@/i18n/translate";
import { AccomplishmentData } from "./FacultySuccessExportView";

interface FacultySuccessCollegesTableProps {
  accomplishmentByCategory: AccomplishmentData;
  categoryColumnHeader: string;
}

export default function FacultySuccessCollegesTable({
  accomplishmentByCategory,
  categoryColumnHeader
}: FacultySuccessCollegesTableProps): JSX.Element {
  return (
    <>
      <div>
        <Table>
          <TableHeader
            columns={[
              categoryColumnHeader,
              translate("app.faculty.grants"),
              translate("app.faculty.publications"),
              translate("app.faculty.intellectualProperty"),
              translate("app.faculty.performances"),
              translate("app.faculty.presentations"),
              translate("app.faculty.total")
            ]}
          />
          <TableBody accomplishmentByCategory={accomplishmentByCategory} />
        </Table>
      </div>
    </>
  );
}
const TableBody = (props: any) => {
  const accomplishmentByCategory = props.accomplishmentByCategory;
  return (
    <tbody className="databody">
      {Object.keys(accomplishmentByCategory)
        .sort()
        .map((collegeName: string, index: number) => (
          <tr className="datarow" key={`${collegeName}${index}`}>
            <td className="datacell">{collegeName}</td>
            {Object.keys(accomplishmentByCategory[collegeName]).map(
              (category: string, index: number) => (
                <td className="datacell" key={`${category}${index}`}>
                  {accomplishmentByCategory[collegeName][category]}
                </td>
              )
            )}
          </tr>
        ))}
    </tbody>
  );
};
const Table = (props: any) => {
  return <table className="data-table -shadow">{props.children}</table>;
};

export const TableHeader = (props: any) => {
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {props.columns.map((column: string, index: number) => {
          return (
            <th
              className="dataheadercell"
              data-th={column}
              key={`column-${index}`}
            >
              {column}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
